module.exports = __webpack_public_path__ + "static/media/stamp_15.90675df2.png";